import React from 'react';
import styled from 'styled-components';
import { NavLink } from "react-router-dom";

const FooterContainer = styled.footer`
  background-color: #f8f9fa;
  padding: 0.5rem;
  text-align: center;
  border-top: 1px solid #ddd;
  width: 100%;
  box-sizing: border-box;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FooterNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  
  @media (min-width: 768px) {
    gap: 1rem;
  }
`;

const FooterLink = styled(NavLink)`
  text-decoration: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  padding: 3px 8px;
  
  @media (min-width: 768px) {
    font-size: 14px;
  }
  
  &:hover {
    text-decoration: underline;
  }
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterNav>
        <FooterLink to="/help">Trợ giúp</FooterLink>
        <FooterLink to="/search">Tìm kiếm</FooterLink>
        <FooterLink to="/privacy">Privacy</FooterLink>
        <FooterLink to="/contact">Liên hệ</FooterLink>
      </FooterNav>
    </FooterContainer>
  );
}

export default Footer;